import { ChangeDetectionStrategy, Component, computed, inject, input, OnDestroy, OnInit } from '@angular/core';
import { I18n, NgtCardComponent } from '@corporate/ng-tebis-base-components';
import { AIForm } from '../../../../03_model/ai-chat-message.model';
import { AssistantMessageComponent } from '../../../assistant/assistant-message/assistant-message.component';
import { OrdersByIdsService, OrderSearchResultMessageViewModel } from './orders-by-ids.service';
import { ReactiveStateFacadeService } from '../../../../01_core/state-management/reactive-state-facade.service';

export type OrderSearchResultMessageData = {
  message: string;
  orderIDs: string[];
};

@Component({
  selector: 'tps-order-search-result-message',
  imports: [
    AssistantMessageComponent,
    NgtCardComponent,
  ],
  templateUrl: './order-search-result-message.component.html',
  styleUrls: ['./order-search-result-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ReactiveStateFacadeService],
})
export class OrderSearchResultMessageComponent implements AIForm, OnInit, OnDestroy {

  i18n = inject(I18n);
  service = inject(OrdersByIdsService);
  private readonly viewState: ReactiveStateFacadeService<OrderSearchResultMessageViewModel> = inject(ReactiveStateFacadeService);

  data = input.required<OrderSearchResultMessageData>();
  update = input.required<(newData: any) => void>();

  message = computed(() => this.data().message || '');
  viewData = this.viewState.value;
  orders = computed(() => this.viewData()?.orders || []);

  viewKey: string|null = null;

  constructor() {
    this.i18n.addNamespace('manufacturing-order');
  }

  ngOnInit() {
    this.viewKey = this.data().orderIDs.join(',');
    this.viewState.connect(this.service.activateViewIdentity(this.viewKey, this.data().orderIDs));
  }

  ngOnDestroy() {
    if (this.viewKey) {
      this.service.deactivateViewIdentity(this.viewKey);
    }
  }
}
